import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
  beforeLoad: ({ context, search }) => {
    const isHomePageActive = context.flags["exibe-home-no-app"];
    if (isHomePageActive) {
      redirect({ to: "/home/", throw: true, search });
    } else {
      redirect({ to: "/calendar/", throw: true, search });
    }
  },
});
